// pages/FormView/FormViewPage.tsx
// całkowita zamiana w Krok 3 (pierwotny poniżej zakomentowany)

// src/pages/FormView/FormViewPage.tsx

import React, { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Breadcrumbs, 
  Link, 
  IconButton,
  Alert,
  CircularProgress 
} from '@mui/material';
import { ArrowBack, Home } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchFormTemplate, clearCurrentForm } from '../../store/slices/formsSlice';
import { FormRenderer } from '../../components/forms/FormRenderer';

export const FormViewPage: React.FC = () => {
  const { formTemplateId } = useParams<{ formTemplateId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const nodeId = searchParams.get('nodeId');
  const { currentForm, isLoading, error } = useAppSelector((state: any) => state.forms);
  const { selectedNode } = useAppSelector((state: any) => state.nodes);

  useEffect(() => {
    if (formTemplateId) {
      const id = parseInt(formTemplateId, 10);
      if (!isNaN(id)) {
        dispatch(fetchFormTemplate(id));
      }
    }

    // Cleanup on unmount
    return () => {
      dispatch(clearCurrentForm());
    };
  }, [formTemplateId, dispatch]);

  const handleBackToObjects = () => {
    if (nodeId) {
      navigate(`/objects/${nodeId}`);
    } else {
      navigate('/objects');
    }
  };

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  if (isLoading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="60vh"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Ładowanie formularza...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: 3 }}>
          <Breadcrumbs>
            <Link 
              color="inherit" 
              href="#" 
              onClick={handleBackToDashboard}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Home sx={{ mr: 0.5 }} fontSize="inherit" />
              Dashboard
            </Link>
            <Link 
              color="inherit" 
              href="#" 
              onClick={handleBackToObjects}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              Objects
            </Link>
            {selectedNode && (
              <Typography color="text.primary">{selectedNode.name}</Typography>
            )}
            <Typography color="text.primary">Formularz</Typography>
          </Breadcrumbs>
        </Box>

        {/* Back Button */}
        <Box sx={{ mb: 3 }}>
          <IconButton onClick={handleBackToObjects} sx={{ mr: 2 }}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" component="span">
            Błąd ładowania formularza
          </Typography>
        </Box>

        {/* Error Alert */}
        <Alert severity="error" sx={{ maxWidth: 800 }}>
          <Typography variant="h6" gutterBottom>
            Nie udało się załadować formularza
          </Typography>
          <Typography variant="body2">
            {error}
          </Typography>
        </Alert>
      </Box>
    );
  }

  if (!currentForm) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          Formularz nie został znaleziony.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Breadcrumbs */}
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs>
          <Link 
            color="inherit" 
            href="#" 
            onClick={handleBackToDashboard}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Dashboard
          </Link>
          <Link 
            color="inherit" 
            href="#" 
            onClick={handleBackToObjects}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            Objects
          </Link>
          {selectedNode && (
            <Typography color="text.primary">{selectedNode.name}</Typography>
          )}
          <Typography color="text.primary">{currentForm.name}</Typography>
        </Breadcrumbs>
      </Box>

      {/* Back Button */}
      <Box sx={{ mb: 3 }}>
        <IconButton onClick={handleBackToObjects} sx={{ mr: 2 }}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h4" component="span">
          {currentForm.name}
        </Typography>
      </Box>

      {/* Form Renderer */}
      {/* // ============================================================================================= */}
      {/* // ==== Zmiana w Krok 4B >>>> */}
      {/* // ==== z: */}
      {/* //<FormRenderer formTemplateId={parseInt(formTemplateId!, 10)} /> */}
      {/* // ==== na: */}
       <FormRenderer 
      formTemplateId={parseInt(formTemplateId!, 10)} 
      nodeId={parseInt(nodeId!, 10)} 
      />
    </Box>
  );
};






// ======================== pierwotni uteorzony - chyba tylko dla mockupów
// import React, { useState } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormGroup,
//   FormControlLabel,
//   Alert,
// } from '@mui/material';

// const FormViewPage: React.FC = () => {
//   const { formId, objectId } = useParams<{ formId: string; objectId?: string }>();
//   const [formData, setFormData] = useState<Record<string, any>>({});
//   const [submitted, setSubmitted] = useState(false);

//   // Mock form structure
//   const formStructure = {
//     id: parseInt(formId || '1'),
//     name: 'Kontrola jakości',
//     sections: [
//       {
//         id: 'quality_check',
//         type: 'select-one',
//         label: 'Status kontroli jakości',
//         required: true,
//         options: ['Przeszła', 'Nie przeszła', 'Wymaga ponownej kontroli'],
//       },
//       {
//         id: 'temperature',
//         type: 'number',
//         label: 'Temperatura (°C)',
//         required: true,
//       },
//       {
//         id: 'defects',
//         type: 'select-many',
//         label: 'Wykryte defekty',
//         required: false,
//         options: ['Zarysowania', 'Pęknięcia', 'Odbarwienia', 'Brak defektów'],
//       },
//       {
//         id: 'notes',
//         type: 'text',
//         label: 'Uwagi',
//         required: false,
//       },
//     ],
//   };

//   const handleInputChange = (sectionId: string, value: any) => {
//     setFormData(prev => ({
//       ...prev,
//       [sectionId]: value,
//     }));
//   };

//   const handleSubmit = () => {
//     console.log('Form submitted:', formData);
//     setSubmitted(true);
//     // Tutaj będzie logika wysyłania formularza
//   };

//   const renderFormSection = (section: any) => {
//     const value = formData[section.id] || '';

//     switch (section.type) {
//       case 'select-one':
//         return (
//           <FormControl fullWidth required={section.required}>
//             <InputLabel>{section.label}</InputLabel>
//             <Select
//               value={value}
//               label={section.label}
//               onChange={(e) => handleInputChange(section.id, e.target.value)}
//             >
//               {section.options.map((option: string) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         );

//       case 'number':
//         return (
//           <TextField
//             fullWidth
//             type="number"
//             label={section.label}
//             required={section.required}
//             value={value}
//             onChange={(e) => handleInputChange(section.id, e.target.value)}
//           />
//         );

//       case 'text':
//         return (
//           <TextField
//             fullWidth
//             multiline
//             rows={3}
//             label={section.label}
//             required={section.required}
//             value={value}
//             onChange={(e) => handleInputChange(section.id, e.target.value)}
//           />
//         );

//       case 'select-many':
//         return (
//           <Box>
//             <Typography variant="subtitle2" gutterBottom>
//               {section.label} {section.required && '*'}
//             </Typography>
//             <FormGroup>
//               {section.options.map((option: string) => (
//                 <FormControlLabel
//                   key={option}
//                   control={
//                     <Checkbox
//                       checked={(value || []).includes(option)}
//                       onChange={(e) => {
//                         const currentValues = value || [];
//                         const newValues = e.target.checked
//                           ? [...currentValues, option]
//                           : currentValues.filter((v: string) => v !== option);
//                         handleInputChange(section.id, newValues);
//                       }}
//                     />
//                   }
//                   label={option}
//                 />
//               ))}
//             </FormGroup>
//           </Box>
//         );

//       default:
//         return null;
//     }
//   };

//   if (submitted) {
//     return (
//       <Box>
//         <Alert severity="success" sx={{ mb: 2 }}>
//           Formularz został wysłany pomyślnie!
//         </Alert>
//         <Button onClick={() => setSubmitted(false)}>
//           Wypełnij ponownie
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Typography variant="h4" gutterBottom>
//         {formStructure.name}
//       </Typography>
      
//       {objectId && (
//         <Typography variant="subtitle1" color="text.secondary" gutterBottom>
//           Obiekt: {objectId}
//         </Typography>
//       )}

//       <Card sx={{ mt: 2 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//             {formStructure.sections.map((section) => (
//               <Box key={section.id}>
//                 {renderFormSection(section)}
//               </Box>
//             ))}

//             <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
//               <Button variant="outlined">
//                 Zapisz jako szkic
//               </Button>
//               <Button variant="contained" onClick={handleSubmit}>
//                 Wyślij formularz
//               </Button>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default FormViewPage;